// ============================================================================
// SUNBORN // WALL ART SWATCH VISIBILITY FIX
// ----------------------------------------------------------------------------
// Root cause: VariantSelects.setAvailability() (assets/main-product.js) only
// toggles a `data-disabled` attribute on swatch elements when the customer
// changes Size/Format after page load — it never removes/hides the element.
// That's correct behavior for normal apparel (disabled-but-visible swatches),
// but wrong for Wall Art, where dead Size×Format combos (e.g. Hanger Oak only
// existing at 24x36) should disappear entirely, matching the {% continue %}
// behavior already used for the *first* server-rendered state in
// main-product.liquid.
//
// Fix: monkey-patch the `variant-selects` custom element's prototype method
// so that, ONLY when the product wrapper carries
// data-product-template="wall-art" (added to the .bls__template-product div
// in main-product.liquid), unavailable swatches get display:none instead of
// just the data-disabled attribute. All other templates are untouched —
// falls through to original disable-only behavior.
//
// IDEMPOTENT: guarded by prototype flag + window flag.
// ============================================================================
(function sunbornWallArtSwatchVisibility() {
  if (window.__sunbornWallArtSwatchFix_active) return;
  window.__sunbornWallArtSwatchFix_active = true;

  function isWallArt(el) {
    var wrapper = el.closest(".bls__template-product");
    return !!(wrapper && wrapper.dataset.productTemplate === "wall-art");
  }

  function patch() {
    if (typeof customElements === "undefined") return false;
    var ctor = customElements.get("variant-selects");
    if (!ctor || !ctor.prototype) return false;
    if (ctor.prototype.__sunbornWallArtPatched) return true;

    var originalSetAvailability = ctor.prototype.setAvailability;
    if (typeof originalSetAvailability !== "function") return false;

    ctor.prototype.setAvailability = function (listOfOptions, listOfAvailableOptions) {
      var wallArt = isWallArt(this);
      listOfOptions.forEach(function (input) {
        var available = listOfAvailableOptions.indexOf(input.dataset.value) > -1;
        if (available) {
          input.removeAttribute("data-disabled");
          if (wallArt) input.style.removeProperty("display");
        } else {
          input.setAttribute("data-disabled", "disable");
          // Theme CSS sets `.bls__option-swatch { display: flex !important; }`,
          // so a plain inline style assignment is silently overridden. Use
          // setProperty with the "important" priority flag to actually win.
          if (wallArt) input.style.setProperty("display", "none", "important");
        }
      });
    };

    ctor.prototype.__sunbornWallArtPatched = true;

    // Force an initial sync pass: swatches now always render fully in
    // Liquid (the old {% continue %} that pruned them at load time was
    // removed), so on first page load every Format value is present in
    // the DOM regardless of the selected Size. updateVariantStatuses()
    // has only ever run on customer interaction (onVariantChange) — call
    // it once now for each wall-art variant-selects element so the
    // initially-invalid combos are hidden immediately, not just after
    // the customer touches a swatch.
    document.querySelectorAll("variant-selects").forEach(function (el) {
      if (isWallArt(el) && typeof el.updateVariantStatuses === "function") {
        try {
          el.updateVariantStatuses();
        } catch (e) {
          /* no-op: element may not be fully initialized yet */
        }
      }
    });

    return true;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", patch);
  } else {
    patch();
  }

  // customElements.define for "variant-selects" happens in main-product.js,
  // which may not have executed yet when this script parses (defer ordering).
  // Retry briefly until the prototype exists and is patched.
  var tries = 0;
  var retry = setInterval(function () {
    tries++;
    if (patch() || tries > 20) clearInterval(retry);
  }, 250);
})();
